var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}

site.boxman = {
	init: function () {
		$("#dialog").on("dialogopen", function (event, ui) {
			site.boxman.waitUntil(function () {
				return $('input#class.hidden').length > 0;
			}, function () {
				$('input#class.hidden').removeClass('hidden').addClass('text').attr('type', 'text').wrap('<dd id="class-element" />').wrap('<span class="lmnt" />').closest('dd').prepend('<dt id="class-label"><label for="class" class="optional">Auka klasar</label></dt>');
			}, function () {

			});
		});
	},
	waitUntil: function (isready, success, error, count, interval) {
		if (count === undefined) {
			count = 100;
		}
		if (interval === undefined) {
			interval = 20;
		}
		if (isready()) {
			success();
			return;
		}
		// The call back isn't ready. We need to wait for it
		setTimeout(function () {
			if (!count) {
				// We have run out of retries
				if (error !== undefined) {
					error();
				}
			} else {
				// Try again
				site.boxman.waitUntil(isready, success, error, count - 1, interval);
			}
		}, interval);
	}
};

site.dropdown = {
	init:function() {
		var $body = $('body');
		if (!$body.hasClass('frontpage')) return false;

		site.dropdown.setHeight();
		$(window).resize(function() {
			site.dropdown.setHeight();
		});

		$('.content','#dropdown').on('click', function(e) {
			e.stopPropagation();
		});
		$('.title', '#dropdown').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$body.toggleClass('dropdown-open');
			$('body.dropdown-open').on('click', function () {
				$('body').removeClass('dropdown-open');
			});
		});
	},

	setHeight:function() {
		var $dropdown = $('#dropdown');
		$('ul', $dropdown).show();
		$('.content', $dropdown).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
		$('ul', $dropdown).removeAttr('style');
	}
};

site.arrowList = {
	init: function () {
		var $list = $('body .entryContent ul');
		if($list.length > 0) {
			$('.entryContent ul li').each(function () {
				var $link = $(this).find('a');
				if($link.attr('href') !== undefined) {
					$(this).addClass('link');
					$href = $link.attr('href').toLowerCase();
					if($href.indexOf('.pdf') > -1) {
						$(this).addClass('pdf');
					}
					if($href.indexOf('.doc') > -1 || $href.indexOf('.docx') > -1) {
						$(this).addClass('doc');
					}
					if($href.indexOf('mailto:') > -1) {
						$(this).addClass('mailto');
					}
					if($href.indexOf('tel:') > -1) {
						$(this).addClass('tel');
					}
					if($link.attr('target') === '_blank') {
						$(this).addClass('external');
					}
				}
			});
		}
	},
};

site.ibudarlan = {
	init: function () {
		var bankBranch = new Map();
		bankBranch.set('sparisjodur-s-thingeyinga', 'https://reiknivel-spthin.spar.is/');
		bankBranch.set('sparisjodur-strandamanna','https://reiknivel-spstr.spar.is/');
		bankBranch.set('sparisjodur-hofdhverfinga','https://reiknivel-spsh.spar.is/');
		bankBranch.set('sparisjodur-austurlands','https://reiknivel-sparaust.spar.is/');

		$('.ibudarlanIframeInline').click(function (e) {
			e.preventDefault();
			document.getElementById('reiknivelIframeContainer').scrollIntoView({ behavior: 'smooth', inline: "start" });
		});

		$('.ibudarlanIframe').click(function () {
				var pathname = new URL(window.location.href).pathname;
				var currentBranch = bankBranch.get(pathname.split('/')[1]);
				if(currentBranch === undefined) {
					currentBranch = 'https://reiknivel.spar.is/'
				}
				site.ibudarlan.husnaedislanFancy(currentBranch);
		});

		$('.skammtimalanIframe').click(function () {
			var pathname = new URL(window.location.href).pathname;
			var currentBranch = bankBranch.get(pathname.split('/')[1]);
			if(currentBranch === undefined) {
				currentBranch = 'https://reiknivel.spar.is/'
			}
			site.ibudarlan.kjorvaxtalanFancy(currentBranch);
		});
	},
	husnaedislanFancy: function (href) {
		$.fancybox({
			href: href + 'husnaedislan',
			openEasing: 'swing',
			openSpeed: 1000,
			height: '100%',
			width: '100%',
			closeClick    : true,
			closeEffect    : 'fade',
			type: 'iframe'
		});
	},
	kjorvaxtalanFancy: function (href) {
		$.fancybox({
			href: href + 'kjorvaxtalan',
			openEasing: 'swing',
			openSpeed: 1000,
			height: '100%',
			width: '100%',
			closeClick    : true,
			closeEffect    : 'fade',
			type: 'iframe'
		});
	}
};

site.frontpageBanner = {
	init: function () {
		site.owl.init('#banner ul', {
			loop: true,
			dots: true,
			margin: 0,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			nav: false,
			items: 1,
			navText: ["", ""],
			autoplay: true,
			smartSpeed: 700,
			autoplayTimeout: 10000,
			autoplayHoverPause: true,
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	var $body = $('body');

	site.megamenu.init();
	site.dropdown.init();
	site.arrowList.init();

	if($('body').find('.skammtimalanIframe').length > 0 || $('body').find('.ibudarlanIframe').length > 0 || $('body').find('.ibudarlanIframeInline').length > 0) {
		site.ibudarlan.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#header, #main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	if ($body.is('.frontpage')) {
		site.frontpageBanner.init();
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
